import {
  KYC_TYPE,
  PAGE_SECTIONS_KEYS,
} from "features/ManageOfferings/modules/OfferingPageSections/constants/OfferingPageSectionsKeys.constants";

export const PER_TIER_KYC_MODE = {
  INHERIT: "inherit",
  CUSTOM: "custom",
};

export const PER_TIER_KYC_CONTEXT = {
  MEMBERSHIP: "membership",
  VARIATION: "variation",
};

export const PER_TIER_KYC_FIELD_KEYS = {
  MODE: "mode",
  MODE_INPUT_NAME: "kyc_mode",
  ENABLED: "enabled",
  KYC_OVERRIDE: "kyc_override",
  KYC_STATUS: "kyc_status",
  KYC_TYPE: PAGE_SECTIONS_KEYS.KYC_TYPE,
  CONTRACT_PDF_URL: PAGE_SECTIONS_KEYS.CONTRACT_PDF_URL,
  KRA_CONTRACT_URL: PAGE_SECTIONS_KEYS.KRA_CONTRACT_URL,
  KYC_WORKFLOW: PAGE_SECTIONS_KEYS.KYC_WORKFLOW,
  IS_ESIGN_ENABLED: PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED,
  ESIGN_PLACEMENT: PAGE_SECTIONS_KEYS.ESIGN_PLACEMENT,
  IS_DIGIO_KYC_ENABLED: PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED,
};

export const PER_TIER_KYC_METHOD = KYC_TYPE;

export const PER_TIER_KYC_COPY = {
  COLUMN_HEADER: "KYC Verification",
  STATUS_INHERIT: "Offering default",
  STATUS_CUSTOM: "Custom",
  TITLE_PREFIX: "KYC Verification",
  SUBTITLE: {
    [PER_TIER_KYC_CONTEXT.MEMBERSHIP]:
      "Configure identity verification for this membership tier.",
    [PER_TIER_KYC_CONTEXT.VARIATION]:
      "Configure identity verification for this variation.",
  },
  MODE_LABEL: "Verification method",
  MODE_INHERIT: "Use Offering's KYC Verification",
  MODE_CUSTOM: {
    [PER_TIER_KYC_CONTEXT.MEMBERSHIP]:
      "Use Custom KYC Verification for this membership",
    [PER_TIER_KYC_CONTEXT.VARIATION]:
      "Use Custom KYC Verification for this variation",
  },
  INHERIT_HELPER:
    "The offering's KYC configuration will apply to this tier. Settings below are shown for reference and cannot be edited here.",
  METHOD_SECTION_TITLE: "KYC Verification Method",
  KRA_REQUEST_BANNER: "Request Verification for KRA Workflow",
  ENABLE_TOGGLE_AADHAAR: "Enable Aadhaar e-signing",
  ENABLE_TOGGLE_KRA: "Enable KRA workflow",
  PLACEMENT_TITLE: "When to perform e-signing of contract?",
  PLACEMENT_DESC:
    "The customer will find this contract at checkout, either before or after the booking as per your selection.",
  CONTRACT_URL_LABEL: "Contract for redirection (URL)",
  CONTRACT_URL_PLACEHOLDER: "Paste URL",
  CONTRACT_UPLOAD_LABEL: "Or upload a contract document",
  CONTRACT_UPLOAD_BUTTON: "Upload document",
  KRA_UPLOAD_BUTTONS: [
    {
      btnText: "Upload NDML/CDSL Customer Registration Form",
      fileLabel: "NDML/CDSL Customer Registration Form",
    },
    { btnText: "Upload Contract", fileLabel: "Contract" },
  ],
  CONTRACT_FILE_LABEL: "Contract",
  WORKFLOW_LABEL: "KRA workflow (optional)",
  WORKFLOW_PLACEHOLDER: "Digio template name",
  WORKFLOW_HELPER: "Leave blank to use the offering's KRA workflow.",
  OR_DIVIDER: "OR",
  SAVE: "Save changes",
  CANCEL: "Cancel",
  CONFIRM_TITLE: "Confirm custom KYC",
  CONFIRM_BODY:
    "This overrides the offering's default KYC configuration for this specific tier.",
  CONFIRM_ACK:
    "I am responsible for the legal and regulatory compliance of this custom configuration.",
  CONFIRM_ACTION: "Confirm & save",
  GO_BACK: "Go back",
  MENU_KYC: "Update KYC verification",
  MENU_DELETE: "Delete",
};

export const PER_TIER_KYC_ERRORS = {
  METHOD_REQUIRED: "Please select a verification method.",
  CONTRACT_REQUIRED: "Please paste a contract URL or upload a document.",
  CONTRACT_URL_INVALID: "Please enter a valid URL.",
  KRA_DOCS_REQUIRED: "Please upload both KRA documents.",
};

export const PER_TIER_KYC_STYLE = {
  MODAL_WIDTH: "560px",
  ICON_COLOR: "#493AB1",
  MENU_DELETE_COLOR: "#BF2600",
  BADGE_INHERIT_BG: "tw-bg-[#493AB122]",
  BADGE_INHERIT_TEXT: "tw-text-[#493AB1]",
  BADGE_INHERIT_DOT: "tw-bg-[#493AB1]",
  BADGE_CUSTOM_BG: "tw-bg-[#FF8A0022]",
  BADGE_CUSTOM_TEXT: "tw-text-[#B25E00]",
  BADGE_CUSTOM_DOT: "tw-bg-[#FF8A00]",
};

export const PER_TIER_KYC_UPLOAD = {
  ACCEPT: "application/pdf",
  BASE_PATH_PREFIX: "contracts",
};

export const PER_TIER_KYC_OFFERING = {
  SETTINGS_PATH: ({ listingUuid }) =>
    `users/adminpanel/setting/listing/${listingUuid}?feature_keys=${[
      PAGE_SECTIONS_KEYS.KYC_TYPE,
      PAGE_SECTIONS_KEYS.CONTRACT_PDF_URL,
      PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED,
      PAGE_SECTIONS_KEYS.ESIGN_PLACEMENT,
      PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED,
      PAGE_SECTIONS_KEYS.KRA_CONTRACT_URL,
    ].join(",")}`,
};
